import "firebase/auth";
import "firebase/firestore";
import "utils/dayjs";

import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import * as Sentry from "@sentry/react";
import App from "App";
// import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import firebaseConfig from "firebaseConfig";
import React from "react";
import { createRoot } from "react-dom/client";
import theme from "theme";

import Pace from "./components/shared/Pace";

const hostRegex = (input) => {
  const hostname = input
    .trim()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "");
  const escaped = hostname.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return new RegExp(`^https?:\\/\\/${escaped}(?::\\d+)?(?:\\/|$)`);
};

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_RELEASE,
  environment: import.meta.env.VITE_ENV,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: [
    hostRegex("localhost"),
    import.meta.env.VITE_ALLOWED_TRACING_URL &&
      hostRegex(import.meta.env.VITE_ALLOWED_TRACING_URL),
  ].filter(Boolean),
  ignoreErrors: [
    // Ignore Unhandled Rejection errors: See https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/14
    "Non-Error promise rejection captured",
    // Ignore resize observer limits: See https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
    "ResizeObserver loop limit exceeded",
  ],
  tracesSampleRate: 0.3,
});

try {
  initializeApp(firebaseConfig);
  getAnalytics();
  // initializeAppCheck(app, {
  //   provider: new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_V3),
  //
  //   // Optional argument. If true, the SDK automatically refreshes App Check
  //   // tokens as needed.
  //   isTokenAutoRefreshEnabled: true
  // });
} catch (err) {
  Sentry.captureException(err);
}

const container = document.querySelector("#root");
const root = createRoot(container);

root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      <Pace color={theme.palette.primary.main} />
      <App />
    </ThemeProvider>
  </StyledEngineProvider>,
);
